import React from 'react';
import { BarChart2 } from 'lucide-react';
import { RotatingLines } from 'react-loader-spinner';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

/**
 * Pill indicator shown while a chart is streaming - matches InlineToolCallIndicator style.
 * Shows "Generating pie chart" or "Generating bar chart" with spinner.
 */
const ChartStreamingIndicator = ({ isDark = false, chartType = 'chart' }) => {
  const borderColor = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)';
  const backgroundColor = isDark ? '#121212' : '#f4f4f5';
  const iconColor = isDark ? '#ffffff' : '#111111';
  const spinnerColor = isDark ? '#ffffff' : '#111111';

  const label = chartType === 'pie' ? 'Generating pie chart' : chartType === 'bar' || chartType === 'line' ? 'Generating bar chart' : 'Generating chart';

  return (
    <div
      className="relative flex items-center gap-1.5 py-0.5 pl-0.5 pr-0.5 rounded-full border w-fit mb-2 leading-none mt-0.5"
      style={{ borderColor, backgroundColor }}
    >
      <span className="flex items-center justify-center w-[16px] h-[16px] rounded-[4px] flex-shrink-0" style={{ color: iconColor }}>
        <BarChart2 size={14} strokeWidth={2} />
      </span>
      <span className="flex-shrink-0 text-[13px] font-medium h-4 flex items-center overflow-hidden" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
        <SkeletonTheme
          baseColor={isDark ? '#404040' : '#6b7280'}
          highlightColor={isDark ? '#ffffff' : '#000000'}
        >
          <div
            style={{
              width: '140px',
              height: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                width: '140px',
                height: '16px',
                overflow: 'hidden',
                maskImage: `url("data:image/svg+xml,${encodeURIComponent(
                  `<svg width="140" height="16" viewBox="0 0 140 16" xmlns="http://www.w3.org/2000/svg">
                    <text x="0" y="12" font-family="system-ui, -apple-system, sans-serif" font-size="13" font-weight="500" fill="black">${label.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')}</text>
                  </svg>`
                )}")`,
                WebkitMaskImage: `url("data:image/svg+xml,${encodeURIComponent(
                  `<svg width="140" height="16" viewBox="0 0 140 16" xmlns="http://www.w3.org/2000/svg">
                    <text x="0" y="12" font-family="system-ui, -apple-system, sans-serif" font-size="13" font-weight="500" fill="black">${label.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')}</text>
                  </svg>`
                )}")`,
                maskSize: 'contain',
                WebkitMaskSize: 'contain',
                maskRepeat: 'no-repeat',
                WebkitMaskRepeat: 'no-repeat',
                maskPosition: 'left center',
                WebkitMaskPosition: 'left center',
              }}
            >
              <Skeleton width={140} height={16} style={{ borderRadius: 0, display: 'block', margin: 0, padding: 0, lineHeight: 1, minHeight: 16 }} />
            </div>
          </div>
        </SkeletonTheme>
      </span>
      <span className="flex-shrink-0 ml-0.5 flex items-center justify-center w-4 h-4">
        <RotatingLines
          visible={true}
          width="14"
          strokeWidth="4"
          strokeColor={spinnerColor}
          animationDuration="0.75"
          ariaLabel="chart-loading"
        />
      </span>
    </div>
  );
};

export default ChartStreamingIndicator;
